

const getters = {
  token: state => state.user.token,
  location: state => state.location.locationInfo,
  userInfo: state => state.user.userInfo,
  userInte: state => state.user.userInte,
  userSurplus: state => state.user.userSurplus,
  searchHistory: state => state.search.histories,
  mainPlatform: state => {
    return state.user.mianPlatform
  },
  welfareCards: state => {
    return state.user.welfareCards || []
  }
}

export default getters